module.exports = __webpack_public_path__ + "static/media/thirteen.1b9193e3.JPG";